import { useEffect } from "react";
import { useAuthContext } from "../../../context/AmplifyContext";
import useIsSwapAgency from "../../hooks/useIsSwapAgency";
import { pylonChatKey } from "../../../shared/const/pylonChat";
import { usePylonSignature } from "../../hooks/usePylonSignature";

function Pylon() {
  const { userAttributes } = useAuthContext();
  const isSwapAgency = useIsSwapAgency();
  const { pylonData, fetchSignature, isSuccess } = usePylonSignature({
    email: userAttributes?.email,
  });

  useEffect(() => {
    if (userAttributes?.email) {
      fetchSignature();
    }
  }, [userAttributes?.email, fetchSignature]);

  useEffect(() => {
    if (userAttributes && isSuccess && pylonData?.signature) {
      (window as any).pylon = {
        chat_settings: {
          app_id: pylonChatKey,
          email: userAttributes.email,
          name: userAttributes.name,
          avatar_url: userAttributes.picture,
          hide_default_launcher: isSwapAgency, // hide Pylon launcher for swap agency
          email_hash: pylonData.signature,
        },
      };
    }
  }, [isSwapAgency, userAttributes, isSuccess, pylonData]);
  return null;
}

export default Pylon;
